<template>
  <main>
    <header>
      <img src="/assets/color-logo.svg" alt>
      <span>ID #{{ event.id }}</span>
    </header>
    <dl>
      <dt>Organizator (prodavatelj)</dt>
      <dd v-if="event.organization">{{ event.organization.publicName }}</dd>
      <dt>Datum i vrijeme događaja</dt>
      <dd>{{ formatDate(event.from) }}</dd>
      <dt>Datum i vrijeme izrade obračuna</dt>
      <dd>{{ formatDateTime(now) }}</dd>
    </dl>
    <h1>Obračun prodanih ulaznica br. OB-{{ event.id }}/{{ getYear(now) }}</h1>
    <p class="event-title">{{ event.title }}</p>
    <p class="sale-period">Za period od {{ formatDate(from) }} do {{ formatDate(to) }}</p>
    <table>
      <thead>
        <tr>
          <th>Br.</th>
          <th />
          <th>Naziv</th>
          <th>Jed. cijena</th>
          <th>Promo kod</th>
          <th>Popust</th>
          <th>Količina</th>
          <th>Ukupno</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(info, index) in purchaseInfo" :key="index">
          <td>{{ index + 1 }}.</td>
          <td />
          <td>{{ info.name }}</td>
          <td>{{ info.price }}&nbsp;EUR</td>
          <td>{{ info.promocode }}</td>
          <td>{{ info.discount }} {{ info.discountType === 'PERCENTAGE' ? '%' : 'EUR' }}</td>
          <td>{{ info.soldQuantity }}</td>
          <td>{{ info.total.toFixed(2) }}&nbsp;EUR</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="6">Sveukupno:</td>
          <td>{{ totalSoldCount - refundedOrders.count }}</td>
          <td>{{ round(totalSoldAmount - refundedOrders.amount, 2) }}&nbsp;EUR</td>
        </tr>
      </tfoot>
    </table>
    <p class="vat-info">U gore navedene iznose uključen je PDV ({{ getVATPercentage() }}%).</p>
  </main>
</template>

<script>
import moment from 'moment'
import { getEventSummary } from '@/http'
import { getEventVAT } from '@/utils'

export default {
  props: {
    eventId: String,
  },
  data() {
    return {
      event: {},
      purchaseInfo: [],
      refundedOrders: null,
      from: '',
      to: '',
      totalSoldCount: 0,
      totalSoldAmount: '',
      summaryFrom: null,
      summaryTo: null,
      now: null,
    }
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search)
    const summaryFrom = urlParams.get('from')
    const summaryTo = urlParams.get('to')
    if (summaryFrom && summaryTo) {
      this.summaryFrom = new Date(summaryFrom)
      this.summaryTo = new Date(summaryTo)
    }
    this.getSummaryData()
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD. MM. YYYY')
    },
    getVATPercentage() {
      const parsedVatPercentage = getEventVAT(this.event)

      return Number.isFinite(parsedVatPercentage) ? parsedVatPercentage.toFixed(2) : '0'
    },
    round(num) {
      return (Math.round(num * 100) / 100).toFixed(2)
    },
    formatDateTime(date) {
      return moment(date).format('DD. MM. YYYY HH:mm')
    },
    getYear(date) {
      return moment(date).year()
    },
    async getSummaryData() {
      const summary = await getEventSummary(this.eventId, this.summaryFrom, this.summaryTo)
      this.event = summary.event
      summary.purchaseInfo.map(info => {
        if (!['SUCCESSFUL', 'REFUND_REQUESTED'].includes(info.status)) {
          return
        }
        const existingItem = this.purchaseInfo.find(
          i =>
            i.event_id === info.event_id &&
            i.orderItemId === info.orderItemId &&
            i.promocodeid === info.promocodeid &&
            i.ticket_seller_name === info.ticket_seller_name,
        )
        if (existingItem) {
          existingItem.soldQuantity += info.soldQuantity || 0
          existingItem.total += Number(info.total)
        } else {
          this.purchaseInfo.push({ ...info, total: Number(info.total) })
        }
      })

      this.from = this.summaryFrom || summary.from
      this.to = this.summaryTo || summary.to
      this.totalSoldCount = summary.totalSoldCount
      this.totalSoldAmount = summary.totalSoldAmount
      this.now = new Date()
      this.refundedOrders = summary.refundInfo
    },
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body {
  height: 100%;
}

main {
  /* border-right: 0.11111in dashed #0277bd; */
  height: 100%;
  /* margin-right: 1.333333in; */
  padding: 0.33333in 0.22222in 0.33333in 0.44444in;
}

header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.33333in;
}

header img {
  height: 0.33333in;
}

header span {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.13889in;
  line-height: 120%;
  text-align: right;
  color: #979797;
}

dl {
  margin-bottom: 0.33333in;
}

dl dt {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.11111in;
  line-height: 120%;
  color: #979797;
  margin-bottom: 0.02777in;
}

dl dd {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.13889in;
  line-height: 120%;
  color: #666666;
}

dl dd + dt {
  margin-top: 0.11111in;
}

h1 {
  font-family: 'Raleway', sans-serif;
  font-weight: 800;
  font-size: 0.25in;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #333333;
}

.event-title {
  font-family: 'Raleway', sans-serif;
  font-weight: 800;
  font-size: 0.25in;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #979797;
  margin-bottom: 0.11111in;
}

.sale-period {
  font-family: 'Raleway', sans-serif;
  font-weight: 600;
  font-size: 0.16777in;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #979797;
  margin-bottom: 0.33333in;
}

table {
  width: 100%;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.13889in;
  line-height: 120%;
  color: #333333;
  border-collapse: collapse;
}

table thead {
  background: #e6f1f8;
}

table th {
  font-weight: normal;
  color: #0277bd;
}

table th,
table td {
  padding: 0.08333in 0.11111in;
}

table th:nth-child(-n + 3),
table tbody td:nth-child(-n + 3) {
  text-align: left;
}

table th:nth-child(n + 4),
table tbody td:nth-child(n + 4) {
  text-align: right;
}

table tfoot {
  background: #e6f1f8;
}

table tfoot td {
  color: #0277bd;
  text-align: right;
}

table tr:nth-child(even) {
  background: #f5f5f5;
}

.vat-info {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.11111in;
  line-height: 120%;
  color: #666666;
  margin-top: 0.33333in;
  text-align: right;
}
</style>
